import isEmpty from 'lodash/isEmpty';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tabs from '../../../../../components/layouts/Tabs';
import {
  AppointmentRecord,
  MedicationRecord,
  ProcedureRecord,
} from '../../../../../components/EpisodeOfCareRecord';

function filterItemsByDate(events) {
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const todayEnd = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1,
  );

  return {
    past: events.filter((event) => new Date(event.start) < todayStart),
    current: events.filter((event) => {
      const date = new Date(event.start);
      return date >= todayStart && date < todayEnd;
    }),
    upcoming: events.filter((event) => new Date(event.start) >= todayEnd),
  };
}

const ClinicalEventsList = ({ 'data-testid': testId, events }) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState('current');

  const tabsContent = filterItemsByDate(events);

  const getRecord = (event) => {
    switch (event.domain) {
      case 'appointment':
        return <AppointmentRecord appointment={event} showDateStart />;
      case 'drug':
        return <MedicationRecord medication={event} showDateStart />;
      case 'procedure':
        return <ProcedureRecord procedure={event} showDateStart />;
      default:
        return null;
    }
  };

  const tabs = [
    {
      value: 'past',
      label: t('past'),
      content: !isEmpty(tabsContent.past) ? (
        <div className="stack-4">
          {tabsContent.past.map((event) => getRecord(event))}
        </div>
      ) : (
        <p className="text-sm text-center">{t('empty')}</p>
      ),
    },
    {
      value: 'current',
      label: t('current'),
      content: !isEmpty(tabsContent.current) ? (
        <div className="stack-4">
          {tabsContent.current.map((event) => getRecord(event))}
        </div>
      ) : (
        <p className="text-sm text-center">{t('empty')}</p>
      ),
    },
    {
      value: 'upcoming',
      label: t('upcoming'),
      content: !isEmpty(tabsContent.upcoming) ? (
        <div className="stack-4">
          {tabsContent.upcoming.map((event) => getRecord(event))}
        </div>
      ) : (
        <p className="text-sm text-center">{t('empty')}</p>
      ),
    },
  ];

  const handleOnTabChange = (tab) => setCurrentTab(tab);

  return (
    <Tabs
      data-testid={testId}
      activeKey={currentTab}
      onChange={handleOnTabChange}
      tabs={tabs}
      space={0}
      listClassName="w-full justify-between"
    />
  );
};

ClinicalEventsList.propTypes = {
  'data-testid': PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  events: PropTypes.array,
};

ClinicalEventsList.defaultProps = {
  'data-testid': null,
  events: [],
};

export default ClinicalEventsList;
